import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DxauthService } from 'src/app/dxauth.service';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { Auth0Service } from 'src/app/shared/services/auth0.service';
import { GtmService } from 'src/app/shared/services/gtm.servie';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sokusai-management-register',
  templateUrl: './sokusai-management-register.component.html',
  styleUrls: ['../style/global.css', './sokusai-management-register.component.css'],
})
export class SokusaiManagementRegisterComponent
  extends BaseLoginComponent
  implements OnInit
{
  public acceptTerm = false;
  public acceptPrivacyPolicy = false;
  public isRegistable = false; // SOKUSAIの場合は新規会員登録させない
  public initialized: boolean = true;
  gtmService: GtmService;
  constructor(
    activateRoute: ActivatedRoute,
    auth0: Auth0Service,
    dxauth: DxauthService,
    spinner: NgxSpinnerService,
    public router: Router,
    public title: Title,
    gtmService: GtmService
  ) {
    super(activateRoute, auth0, dxauth, spinner, router, title);
    this.gtmService = gtmService;
  }

  async ngOnInit() {
    const gtmId = environment.apps[this.clientId].gtm?.id;
    if (gtmId) {
      this.gtmService.setGtmId(gtmId);

      this.gtmService.addGtmToDom();
    }
  }

  async init(): Promise<void> {}

  registrationRole(): string {
    return undefined;
  }

  get baseLink() {
    return environment.apps[this.clientId].appUrl;
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId].type);
  }

  get oemId() {
    return environment.apps[this.clientId].oemConfig?.id;
  }

  get privacyUrl() {
    return environment.apps[this.clientId].privacyUrl;
  }

  get termsUrl() {
    return environment.apps[this.clientId].termUrl;
  }

  get appname() {
    return 'ウェルネスクラウド';
  }
}
